<template>
   <div :class="helpClass"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" @click="openHelpText" />
    <div ref="helpText" class="tooltip helptext">
      <div class="columns-6 w-row">
        <div class="column-15 w-col w-col-3">
          <h1 class="heading-6">{{header}}</h1>
        </div>
        <div class="w-col w-col-7">
          <p class="paragraph-2">
            {{text}}
          </p>
        </div>
        <div class="column-14 w-col w-col-2">
          <a href="javascript:;" class="button w-button" @click="closeHelpText">Close</a>
        </div>
      </div>
    </div>
   </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: 'Notification<br />heading'
    },
    text: {
      type: String,
      default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.'
    },
    helpClass: {
      type: String,
      default: 'column-12 w-clearfix w-col w-col-3'
    }
  },
  methods: {
    openHelpText() {
      // console.log(document.querySelectorAll('.tooltip.helptext.show'));
      this.$refs.helpText.classList.add('show');
    },
    closeHelpText() {
      this.$refs.helpText.classList.remove('show');
    }
  }
};
</script>
